/** Format STS keypad token as groups of 4: 1234-5678-9012-3456 */
export function formatStsTokenGroups(token: string | null | undefined): string {
  const digits = String(token || "").replace(/\D/g, "");
  if (!digits) return String(token || "");
  return digits.match(/.{1,4}/g)?.join("-") || digits;
}
